import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ZapOffIcon, EyeOffIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <AlertTriangleIcon className="w-8 h-8 text-red-400" data-id="element-207" />,
    title: 'Miedo a romper el vidrio',
    desc: 'Gastás dinero en materiales caros y un mal corte arruina todo el proyecto. El estrés de perder la inversión.',
    colSpan: 'md:col-span-2'
  }, {
    icon: <ZapOffIcon className="w-8 h-8 text-orange-400" data-id="element-208" />,
    title: 'Cables a la vista',
    desc: 'El efecto se pierde cuando el cliente ve la tira LED mal pegada o los cables colgando.',
    colSpan: 'md:col-span-1'
  }, {
    icon: <EyeOffIcon className="w-8 h-8 text-gray-500" data-id="element-209" />,
    title: 'Falta de profundidad',
    desc: "Hacés todo el trabajo pero el 'efecto infinito' se ve corto, opaco o sin magia. No lográs ese wow factor.",
    colSpan: 'md:col-span-3'
  }];
  return <section className="py-12 bg-[#121212] text-white relative z-10 overflow-hidden" data-id="element-210">
      {/* Chaotic storm textures - blurred distorted shapes */}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-30 overflow-hidden" data-id="element-211">
        <div className="absolute top-10 left-10 w-96 h-96 bg-red-900/20 rounded-full blur-[120px]" data-id="element-212" />
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-gray-800/30 rounded-full blur-[100px]" data-id="element-213" />
        <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-red-800/15 blur-[80px] skew-x-12" data-id="element-214" />
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZ3JpZCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJyZ2JhKDI1NSwyNTUsMjU1LDAuMDIpIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-20" data-id="element-215" />
      </div>

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-216">
        <div className="text-center mb-8" data-id="element-217">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl lg:text-6xl font-black mb-3 tracking-tight text-[#dc2626] leading-[1.05] uppercase" style={{
          textShadow: '0 2px 10px rgba(220, 38, 38, 0.3)'
        }} data-id="element-218">
            EL PROBLEMA REAL
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400 max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-219">
            Si te identificás con alguno de estos problemas, este ebook es para
            vos. Dejá de frustrarte y empezá a crear con seguridad.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-220">
          {problems.map((prob, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15,
          duration: 0.6
        }} className={`${prob.colSpan} bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] rounded-2xl p-8 md:p-10 border border-red-900/20 shadow-[0_8px_30px_rgba(0,0,0,0.6)] backdrop-blur-sm flex flex-col justify-between relative overflow-hidden group`} data-id="element-221">
              {/* Distorted inner glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-red-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-222" />

              <div className="relative z-10" data-id="element-223">
                <div className="bg-[#0a0a0a] w-16 h-16 rounded-xl flex items-center justify-center shadow-inner mb-8 border border-red-900/30 group-hover:scale-110 transition-transform duration-300" data-id="element-224">
                  {prob.icon}
                </div>
                <div data-id="element-225">
                  <h3 className="text-2xl font-black mb-4 text-[#ef4444] tracking-tight uppercase" data-id="element-226">
                    {prob.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed text-base font-medium" data-id="element-227">
                    {prob.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}